const queries = {
  salaryDeductionApplications: () => ['salary-deduction-applications'],
  salaryDeductionApplication: (id: number) => ['salary-deduction-applications', id],
}

export default queries
